import { useEffect } from "react";

/**
 * Lightweight SEO helper: sets document.title and meta description / OG tags.
 * No external dependency.
 */
export default function PageMeta({ title, description, image }) {
    useEffect(() => {
        const prevTitle = document.title;
        if (title) document.title = title;

        const setMeta = (selector, attrs) => {
            let el = document.head.querySelector(selector);
            const created = !el;
            if (created) {
                el = document.createElement("meta");
                Object.entries(attrs.match).forEach(([k, v]) => el.setAttribute(k, v));
                document.head.appendChild(el);
            }
            const prev = el.getAttribute("content");
            el.setAttribute("content", attrs.content || "");
            return () => {
                if (created) el.remove();
                else el.setAttribute("content", prev || "");
            };
        };

        const cleanups = [];
        if (description) {
            cleanups.push(
                setMeta('meta[name="description"]', {
                    match: { name: "description" },
                    content: description,
                }),
            );
            cleanups.push(
                setMeta('meta[property="og:description"]', {
                    match: { property: "og:description" },
                    content: description,
                }),
            );
        }
        if (title) {
            cleanups.push(
                setMeta('meta[property="og:title"]', {
                    match: { property: "og:title" },
                    content: title,
                }),
            );
        }
        if (image) {
            cleanups.push(
                setMeta('meta[property="og:image"]', {
                    match: { property: "og:image" },
                    content: image,
                }),
            );
        }

        return () => {
            document.title = prevTitle;
            cleanups.forEach((fn) => fn && fn());
        };
    }, [title, description, image]);

    return null;
}
